module.exports = __webpack_public_path__ + "img/monica.345c78d4.webp";